import { State } from '../reducers/types'
import {
  ContractorPortalPartner,
  ContractorPortalInvoice,
  ContractorPortalDocument,
  ContractorPortalCertificate,
} from 'src/interfaces/contractorPortal'

export const getContractorPortalPartners = (state: State): ContractorPortalPartner[] =>
  state.contractorPortalPartners.contractorPortalPartners

export const getContractorPortalInvoices = (state: State): ContractorPortalInvoice[] =>
  state.contractorPortalInvoices.contractorPortalInvoices

export const getContractorPortalInvoicesCount = (state: State): number =>
  state.contractorPortalInvoices.contractorPortalInvoicesCount

export const getContractorPortalDocuments = (state: State): ContractorPortalDocument[] =>
  state.contractorPortalDocuments.contractorPortalDocuments

export const getContractorPortalDocumentsCount = (state: State): number =>
  state.contractorPortalDocuments.contractorPortalDocumentsCount

export const getContractorPortalCertificates = (state: State): ContractorPortalCertificate[] =>
  state.contractorPortalCertificates.contractorPortalCertificates

export const getContractorPortalCertificatesCount = (state: State): number =>
  state.contractorPortalCertificates.contractorPortalCertificatesCount
